module.exports = __webpack_public_path__ + "static/media/baug_3.fe9992f1.png";